<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else>
      <div class="text-right">
        <p-button
          type="info"
          class="mr-2"
          @click="printReport"
        >
          Print
        </p-button>
      </div>
      <staff-bios-component
        :staff="staff"
        id="viewBios"
      />
      <staff-bios-print
        :staff="staff"
        id="printBios"
        v-show="false"
      />
      <div class="text-right">
        <p-button
          type="info"
          class="mr-2"
          @click="printReport"
        >
          Print
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import scouterApi from '@/services/api/scouter'
import oops from '@/components/_main/oops.vue'
import staffBiosComponent from '@/components/scouters/staff-bios-component.vue'
import staffBiosPrint from '@/components/scouters/staff-bios-print.vue'
// For testing
// import HtmlToPaperTest from '@/plugins/vue-html-to-paper-test.js'

export default {
  name: 'StaffBios',
  components: {
    oops,
    staffBiosComponent,
    staffBiosPrint
  },
  data: function () {
    return {
      staff: null,
      loading: true,
      errormessage: null,
      printItem: '',
      printOptions: {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/staff-bios.css'
        ]
      }
    }
  },
  mounted () {
    scouterApi
      .getStaffBios(this.$root.courseKey)
      .then(x => {
        this.staff = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    printReport: function () {
      this.printItem = 'printBios'
      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper(this.printItem, this.printOptions)
          // HtmlToPaperTest.show(this.printItem, this.printOptions)
        }
        this.printItem = ''
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width: 100px;
  height: 125px;
}
.pointer {
  cursor: pointer;
}
.card .bigavatar {
  width: 140px;
  height: 140px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
</style>
